/**
 * PeakPricingNotice
 *
 * Displays a factual price breakdown when a booking spans both peak and
 * non-peak pricing windows (isProRated=true). Shows nothing otherwise.
 *
 * Renders inside a <FeatureGate flag={FEATURE_FLAGS.ADDON_PEAK_PRICING}>
 * so it is completely invisible when the feature is disabled.
 *
 * Props intentionally use defaults so callers don't need to handle
 * undefined values when the feature flag is off or data is not yet loaded.
 */

export interface PeakPricingNoticeProps {
  /** Breakdown lines from PricingEngineService.resolveWithPeakPricing() */
  breakdown?: string[];
  /** True when the booking spans both peak and standard-rate windows */
  isProRated?: boolean;
}

export function PeakPricingNotice({ breakdown = [], isProRated = false }: PeakPricingNoticeProps) {
  // Only render when pro-rated AND breakdown has content
  if (!isProRated || breakdown.length === 0) {
    return null;
  }

  return (
    <div
      data-testid="peak-notice"
      className="mt-2 rounded border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800"
    >
      <p className="mb-1 font-medium">Price breakdown (peak hours apply)</p>
      <ul className="space-y-0.5 font-mono text-xs">
        {breakdown.map((line, i) => (
          <li key={i}>{line}</li>
        ))}
      </ul>
    </div>
  );
}
